module.exports = __webpack_public_path__ + "static/media/ninjacow_bc_rb.88fd1a86.png";